import React, { useState } from 'react';
import { CheckBadgeIcon, InformationCircleIcon } from '@heroicons/react/24/solid';

interface VerificationBadgeProps {
  isVerified: boolean;
  isManuallyVerified?: boolean;
  showTooltip?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const VerificationBadge: React.FC<VerificationBadgeProps> = ({ 
  isVerified, 
  isManuallyVerified = false,
  showTooltip = true, 
  size = 'md',
  className = '' 
}) => {
  const [showInfo, setShowInfo] = useState(false);

  console.log(`🏷️ Rendering verification badge: verified=${isVerified}, size=${size}`);

  if (!isVerified) {
    return null; // Don't show anything for unverified teachers
  }

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  return (
    <div className={`relative inline-flex items-center ${className}`}>
      <div className="flex items-center space-x-1">
        <CheckBadgeIcon 
          className={`${sizeClasses[size]} text-blue-500 drop-shadow-sm`}
          title={showTooltip ? "Verified Teacher" : undefined}
        />
        {size !== 'sm' && (
          <span className={`${textSizeClasses[size]} text-blue-600 font-medium`}>
            Verified
          </span>
        )}
      </div>

      {showTooltip && (
        <div className="relative">
          <InformationCircleIcon
            className="w-3 h-3 text-gray-400 ml-1 cursor-help"
            onMouseEnter={() => setShowInfo(true)}
            onMouseLeave={() => setShowInfo(false)}
          />
          
          {showInfo && (
            <div className="absolute z-50 bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg shadow-lg w-64">
              <div className="space-y-1">
                <div className="font-medium">✅ Verified Teacher</div>
                <div className="text-gray-300">
                  This teacher has been verified and is trusted for all lesson formats including:
                </div>
                <ul className="text-gray-300 space-y-0.5 text-xs">
                  <li>• Identity verification completed</li>
                  <li>• Safe for online and in-person lessons</li>
                  <li>• Meets platform quality standards</li>
                  <li>• Authorized for all teaching formats</li>
                </ul>
              </div>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-2 h-2 bg-gray-900 rotate-45"></div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default VerificationBadge; 